/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/guards/app.guards.unsaved-changes.ts.
 */
// unsaved-changes.guard.ts
import {CanComponentDeactivate} from '../interfaces/can-deactivate.interface';
import {Injectable} from '@angular/core';

/**
 * Zweck: Beschreibt class AppGuardsUnsavedChanges und ihren Daten- oder Funktionsvertrag.
 */
@Injectable()
export class AppGuardsUnsavedChanges {
/**
 * Beschreibt Methode canDeactivate und ihren Rückgabevertrag.
 */
  canDeactivate(component: CanComponentDeactivate) {
    return component.canDeactivate();
  }
}
